import React from 'react';
import styles from './MenuButton.module.css';

interface MenuButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  // onClick, type, disabled, title, style sono già in ButtonHTMLAttributes
  children: React.ReactNode;
  icon?: React.ReactNode;
  // className è già in ButtonHTMLAttributes, ma lo teniamo per chiarezza se vogliamo logica custom
  // type è già in ButtonHTMLAttributes
  isActive?: boolean;
}

const MenuButton: React.FC<MenuButtonProps> = ({
  onClick,
  children,
  icon,
  disabled = false,
  className = '', // className dalla prop
  type = "button",
  isActive = false,
  ...rest // Cattura props come title, style, ecc.
}) => {
  // Gestione delle classi con isActive
  // className dalla prop viene ora gestito da ...rest se non specificato in MenuButtonProps
  // o combinato se MenuButtonProps.className è usato esplicitamente
  const combinedClassName = [
    styles.menuButton,
    isActive ? styles.active : '',
    className, // Aggiunge la classe passata tramite props
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={combinedClassName} // Applica le classi combinate
      {...rest} // Passa tutte le altre props, inclusi title e style
    >
      {icon && <span className={styles.iconWrapper}>{icon}</span>}
      {children}
    </button>
  );
};

export default MenuButton;